import { Card } from "@components/card/card";

export function ModeloCardSkeleton() {
  return (
    <Card className="animate-pulse overflow-hidden p-0 shadow-sm md:p-0 lg:p-0">
      <div className="border-b p-3">
        <div className="h-4 w-3/4 rounded bg-neutral-200" />
      </div>
      <div className="flex items-center justify-center gap-2 p-3">
        <div className="h-20 w-1/2 rounded bg-neutral-200" />
        <div className="h-20 w-1/2 rounded bg-neutral-200" />
      </div>
      <div className="flex gap-2 px-3 pb-3">
        <div className="h-6 flex-1 rounded bg-neutral-200" />
        <div className="h-6 flex-1 rounded bg-neutral-200" />
      </div>
    </Card>
  );
}
